import React from 'react'
import styled from 'styled-components'
import Popover from '@material-ui/core/Popover';
import { makeStyles } from '@material-ui/core/styles';

import Button from 'components/common/Button'

const SortOptions = styled.div`
  /* margin-left: 8px;
  margin-right: 8px; */
  /* border: 1px solid #3f76e6; */
  /* border-radius: 4px; */
  &>div {
    display: flex;
    margin-right: 12px;
    margin-top: 16px;
    margin-bottom: 16px;
  }
  .radio-container {
    padding-left: 18px;
    position: relative;
    input {
    position: absolute;
    z-index: 1;
    top: 0;
    left: -13px;
    width: calc(100% + 13px);
    height: 25px;
    opacity:0;
      &+.radio-indicator {
        z-index: 0;
        border: 1px solid #8e8e8e;
        position: absolute;
        left: 0;
        top: 5px;
        border-radius: 50%;
        width: 13px;
        height: 13px;
      }
      &:checked+.radio-indicator {
        background-color: #3f76e6;
        border: 1px solid #3f76e6;
        box-shadow: inset 0px 0px 0px 2px white;
      }
    }
  }
`;
const SortWrapper = styled.div`
  position: relative;
  span.sort-indicator {
    position: absolute;
    top: -12px;
    right: -12px;
    background-color: green !important;
    border-radius: 50% !important;
    width: 24px !important;
    height: 24px !important;
    display: inline-flex;
    align-items: center;
    color: white !important;
  }
  ${Button} {
    display:flex;
    align-items: center;
    padding: 8px 12px !important;
    img {
      margin-left: 12px;
    }
  }
`;
const useStyles = makeStyles((theme) => ({
  root: {

  },
  paper: {
    padding: theme.spacing(2),
    minWidth: 150
  },
}));
const SortButton = ({ sortValue, setSortValue }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleSort = (e) => {
    setSortValue(e.target.value)
  }
  const RadioContainer = ({ value, label, id }) => (
    <div className="radio-container">
      <input type="radio" name="sortOptions" id={id} checked={value === id} onChange={handleSort} value={id} />
      <div className="radio-indicator" />
      <label htmlFor={id}>{label}</label>
    </div>
  )
  return (
    <SortWrapper>
      {sortValue && sortValue !== '' && sortValue !== 'none' && <span className="sort-indicator"></span>}
      <Button variant="outline" onClick={handleClick}>Sort By<img src="/icons/sort.svg" width="24" height="24"/></Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        classes={classes}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <SortOptions>
          <RadioContainer value={sortValue} id="ticketNumber" label="Ticket Number"/>
          <RadioContainer value={sortValue} id="customerNumberStriped" label="Phone Number"/>
          <RadioContainer value={sortValue} id="customerName" label="Customer Name"/>
          <RadioContainer value={sortValue} id="purchaseDate" label="Purchase Date"/>
          <RadioContainer value={sortValue} id="dueDate" label="Due Date"/>
          <RadioContainer value={sortValue} id="none" label="None"/>
        </SortOptions>
      </Popover>
    </SortWrapper>
  )
}

export default SortButton
